/**
 * @Description File description.
 * @FileName fasatElement.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 23 March, 2021 03:01:09
 * @IssueID - Issue IDs
 */

import { useEffect, useState } from 'react';
import './fasatFormElement.scss';
import PropTypes from 'prop-types';

const getSummary = (errors) => {
  if (errors && errors.length > 0) {
    return errors[0].msg;
  }
  return '';
};

function FasatElement(props) {
  const { errors, direction, children, id } = props;

  const [active, setActive] = useState(false);
  const [summary, setSummary] = useState('');

  const hideTip = () => {
    setActive(false);
  };

  const getContent = (errs) => errs.map((i) => <div key={i.msg}>{i.msg}</div>);

  useEffect(() => {
    if (errors && errors.length > 0) {
      setSummary(getSummary(errors));
    } else {
      setSummary('');
    }
  }, [errors]);

  /**
   * Position and errors should be prop
   * 1. if there is errors show summary or return hide error
   */
  return (
    <div
      className="fasat-error-popout-wrapper"
      // When to show the tooltip
      id={id}
    >
      {/* Wrapping */}
      {children}

      {/* <div onClick={showTip} className="truncated summary" aria-hidden="true" role="button"> */}
      <div className="truncated summary" aria-hidden="true" role="button">
        {summary}
        {}
        {}
      </div>

      {active && (
        <div className={`fasat-error-popout ${direction || 'top'}`}>
          {/* Content */}
          <div className="hideError" onClick={hideTip} aria-hidden="true">
            X
          </div>
          {getContent(errors)}
        </div>
      )}
    </div>
  );
}

export default FasatElement;

FasatElement.propTypes = {
  direction: PropTypes.string,
  errors: PropTypes.arrayOf(),
  children: PropTypes.node,
  id: PropTypes.string,
};
FasatElement.defaultProps = {
  direction: 'top',
  errors: [],
  children: null,
  id: '',
};
